import { render, staticRenderFns } from "./MapperIndex.vue?vue&type=template&id=4d4f9f20&scoped=true"
import script from "./MapperIndex.vue?vue&type=script&lang=ts"
export * from "./MapperIndex.vue?vue&type=script&lang=ts"
import style0 from "./MapperIndex.vue?vue&type=style&index=0&id=4d4f9f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4f9f20",
  null
  
)

export default component.exports